import multi from 'redux-multi';
import promise from 'redux-promise';
import rootSaga from './modules/rootSaga';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './modules/rootReducer';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

let middleware = null;
const loggerMiddleware = createLogger();
const sagaMiddleware = createSagaMiddleware();

if (process.env.NODE_ENV !== 'production') {
  middleware = composeWithDevTools(
    applyMiddleware(
      promise,
      multi,
      sagaMiddleware,
      thunkMiddleware,
      loggerMiddleware
    )
  );
} else {
  middleware = applyMiddleware(promise, multi, sagaMiddleware, thunkMiddleware);
}

const store = createStore(rootReducer, middleware);

sagaMiddleware.run(rootSaga);

export default store;
